import CorporatePartnerContainer from './corporate_partner_container';

const CorporatePartner = CorporatePartnerContainer;
export default CorporatePartner;
